"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEB_EVENTS = void 0;
exports.WEB_EVENTS = {
    REQUEST_TOKEN: "INVOKE_REQUEST_TOKEN"
};
//# sourceMappingURL=webEvents.js.map